import React from "react";
import TopNavigation, { Tab } from "../../../components/global_components/TopNavigation";

import "../routes/PermitsList.scss";
import { useSelector } from "react-redux";
import identitySelectors from "../../../selectors/identity";

export const PermitTabs = () => {
  const tabs = usePermitTabs();
  return <TopNavigation tabs={tabs} />;
};

function usePermitTabs(): Tab[] {
  const url = localStorage.getItem("applicationURL");
  const applicationURLObject = JSON.parse(url as string);

  const isInspectionUser = useSelector(identitySelectors.isInspectionsUser);
  const isInspectionAdmin = useSelector(identitySelectors.isInspectionsAdmin);

  const isPermitAdmin = useSelector(identitySelectors.isPermitsAdmin);
  const isPermitUser = useSelector(identitySelectors.isPermitsUser);

  const hasPermitRole = isPermitUser || isPermitAdmin;
  const hasInspectionRole = isInspectionUser || isInspectionAdmin;

  let tabs: Tab[] = [];
  if (hasPermitRole) {
    tabs = [
      {
        to: applicationURLObject,
        label: "Applications",
        activeWhenURLIncludes: ["/permits/applications", "/permits/review"],
      },
      { to: "/permits/renewals", label: "Renewals", activeWhenURLIncludes: "/permits/renewal" },
      { to: "/permits/transactions", label: "Transactions", activeWhenURLIncludes: "/permits/transactions" },
      { to: "/permits/payouts", label: "Payouts", activeWhenURLIncludes: "/permits/payouts" },
      { to: "/permits/reports", label: "Reports", activeWhenURLIncludes: "/permits/reports" },
    ];
  }
  if (hasInspectionRole) {
    if (tabs.length === 0) {
      tabs.push({
        to: "/permits/inspections",
        label: "Inspections",
        activeWhenURLIncludes: "/permits/inspections",
      });
    } else {
      tabs.splice(2, 0, {
        to: "/permits/inspections",
        label: "Inspections",
        activeWhenURLIncludes: "/permits/inspections",
      });
    }
  }

  return tabs;
}

export default PermitTabs;
